import React from "react";
import { ErrorMessage, Formik } from "formik";
import { Button, Form, Modal } from "react-bootstrap";
import * as Yup from "yup";
import { LoadingSpinner } from "../../common/Loading/LoadingSpinner";
import { IEvent } from "./EventCalendar";
import { FormAlert } from "../../Forms";
import { useEventRemove } from "../../../hooks";

type Props = {
  show: boolean;
  onClose: (removed: boolean) => void;
  eventToBeUpdated?: IEvent;
};

const EventRemove: React.FC<Props> = ({ show, onClose, eventToBeUpdated }) => {
  const { alertVariant, currentUser, handleSubmit } = useEventRemove(eventToBeUpdated);

  const handleClose = () => onClose(false);

  const onSubmit = async (values: any, formikHelpers: any) => {
    const success = await handleSubmit(values, formikHelpers);
    if (success) {
      onClose(true);
    }
  };

  return (
    <Modal centered show={show} keyboard={false} onHide={handleClose}>
      <Formik
        initialValues={{
          notes: "",
        }}
        validationSchema={Yup.object().shape({
          notes: Yup.string().required("Notes are required"),
        })}
        onSubmit={onSubmit}
      >
        {({ errors, status, touched, isSubmitting, handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Remove Event</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                Are you sure you want to remove the event{" "}
                <strong>{eventToBeUpdated?.title}</strong>?
              </p>
              <p>This action cannot be undone.</p>

              <Form.Group className="mb-3" controlId="notes">
                <Form.Label>
                  Notes <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="notes"
                  className={
                    "form-control" +
                    (errors.notes && touched.notes ? " is-invalid" : "")
                  }
                />
                <ErrorMessage
                  name="notes"
                  component="div"
                  className="invalid-feedback"
                />
              </Form.Group>

              {status && (
                <FormAlert message={status} variant={alertVariant as 'danger' | 'success' | 'warning' | 'info'} />
              )}
            </Modal.Body>
            <Modal.Footer>
              <div className="form-group">
                <Button
                  variant="danger"
                  disabled={isSubmitting}
                  type="submit"
                  className="me-2"
                >
                  {isSubmitting ? (
                    <LoadingSpinner text="Removing event..." />
                  ) : (
                    "Remove Event"
                  )}
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                  Cancel
                </Button>
              </div>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export { EventRemove };
